<template>
  <div class="login">
    <ul class="language">
        <li>
            <img src="@/assets/image/language-icon.png" alt="">
            <span class="language-content">{{$t('language')}}</span>
            <ul>
                <li @click="changeLang('zh')">中文简体</li>
                <li @click="changeLang('en')">English</li>
            </ul>
        </li>
        <li style="padding:0">
            |
        </li>
        <li>
            <span @click="backHome()">{{$t('backHome')}}</span>
        </li>
    </ul>
    <div class="login-div">
        <img src="@/assets/image/loginLogo.png" alt="">
        <Form :model="loginModel" class="loginForm" ref="loginForm" :rules="loginRules"> 
            <FormItem class="firstFormItem" prop="email">
                <img src="@/assets/image/login-user.png" alt="">
                <Input v-model="loginModel.email" :placeholder="$t('loginEmail')"></Input>
            </FormItem>
            <FormItem style="margin-bottom:50px" prop="password">
                <router-link class="forgetPassword" to="/forgetPassword">{{$t('forgetPassword')}}</router-link>
                <img src="@/assets/image/login-password.png" alt="">
                <Input type="password"  v-model="loginModel.password" :placeholder="$t('loginPassword')"></Input>
            </FormItem>
            <!-- <FormItem>
                <i class="remember" :class="checked?'rememberCheck':''" @click="handleRemember"></i>
                <span class="rememberTxt">{{$t('rememberMe')}}</span>
            </FormItem> -->
            <FormItem>
                <Button class="loginBtn" @click="login">{{$t('loginBtn')}}</Button>
                <Button style="margin-left:30px" class="regBtn" @click="toReg">{{$t('loginReg')}}</Button>
            </FormItem>
        </Form>
    </div>
    <div class="login-txt">
        <p class="footer_title">{{$t('footerTitle1')}}</p>
        <p class="footer_content">
            {{$t('topTips1')}}
        <span>{{$t('topTips2')}}</span>
        {{$t('topTips3')}}</p>
        </p>
        <p class="footer_title">{{$t('footerTitle2')}}</p>
        <p class="footer_content">{{$t('footerTips2')}}</p>
        <p class="footer_title">{{$t('footerTitle3')}}</p>
        <p class="footer_content">{{$t('footerTips3')}}</p>
        <p class="footer_content">{{$t('footerTips4')}}</p>
    </div>
    <loading :isSpinShow="loading"></loading>
  </div>
</template>

<script>
// @ is an alias to /src
import {mapState} from 'vuex'
import { setup } from '@/langs'
import Loading from '@/components/Loading.vue';


export default {
    name: 'Login',
    components: {
        Loading
    },
    data() {
        return {
            loginModel:{
                email:'',
                password:''
            },
            checked:false,
            loginRules: {
                email: [
                    { required: true, message:this.$t('loginTips1') , trigger: 'blur' },
                    { type: 'email', message: this.$t('emailCheck'), trigger: 'blur' }
                ],
                password: [
                    { required: true, message: this.$t('loginTips2') , trigger: 'blur' },
                    // { type: 'string', min: 6, message: '', trigger: 'blur' }
                ]
            },
            loading:false
        }
    },
    computed: {
        ...mapState(['lang'])
    },
    methods: {
        changeLang(value){
            setup(value)
            location.reload()
        },
        handleRemember(){
            this.checked = !this.checked
        },
        toReg(){
            this.$router.push({ path:'/register'})
        },
        backHome(){
            console.log(this.lang)
            if(this.lang == 'en'){
                window.open('https://www.ecmarkets.co.uk', '_blank')
            }else{
                window.open('https://www.ecmarkets.co.uk/zh/', '_blank')
            }
        },
        login(){
            // this.$router.push({ path:'/accountVerify'})
            this.$refs.loginForm.validate((valid) => {
                if (valid) {
                    this.loading = true
                    const data = {
                        email:this.loginModel.email,
                        password:this.$encrypt(this.loginModel.password)
                    }
                    this.$axios.post('/api/Public/Login', data)
                    .then(async (res) => {
                        // console.log(res)
                        if(res.data.status == 1){
                            this.$Message.success(this.$t('loginsuccess'))
                            this.$store.commit('setToken', res.data.obj.token)
                            this.$store.commit('setUserInfo', res.data.obj.userInfo)
                            // debugger
                            if(res.data.obj.userInfo.idCheckResultStatus == 1 || res.data.obj.userInfo.idCheckResultStatus == 0){
                                this.$router.push({ path:'/accountVerify'})
                            }else if(res.data.obj.userInfo.idCheckResultStatus == 3){
                                this.$router.push({ path:'/verifyError'})
                            }else{
                                this.$router.push({ path:'/myAccount'})
                            }
                        }else{
                            this.$Message.error(res.data.msg)
                        }
                    })
                    .catch((err) => this.$Message.error(err.data.msg))
                    .finally(() => this.loading = false)
                }
            })
        }
    }
}
</script>
<style lang="less">
    .login{
        // height: 100%;
        position: relative;
        border: 1px solid transparent;
        // overflow-y:scroll ;
        .language{
            position: absolute;
            right: 2%;
            top: 20px;
            display: flex;
            flex-direction: row;
            li{
                display: flex;
                flex-direction: row;
                align-items: center;
                height: 58px;
                line-height: 58px;
                padding: 0 40px 0 14px;
                color: #d12937;
                cursor: pointer;
                position: relative;
                img{
                    margin-right: 10px;
                }
                .language-content{
                    position: relative;
                }
                .language-content:after{
                    content: "";
                    position: absolute;
                    right: -18px;
                    top: 28px;
                    border-top: 5px solid #d12937;
                    border-left: 5px solid transparent;
                    border-right: 5px solid transparent;
                }
                ul{
                    position: absolute;
                    top: 50px;
                    left: 0;
                    background: #f0f0f0;
                    width: 100%;
                    display: none;
                    li{
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        color: #332c2b;
                        height: 50px;
                        line-height: 50px;
                    }
                    li:hover{
                        color: #d12937;
                    }
                }
            }
            li:hover ul{
                display: block;
            }
        }
        .login-div{
            width: 600px;
            height: 520px;
            // position: absolute;
            left:0; 
            right:0; 
            margin: auto;
            margin-top: 140px;
           
            img{
                // margin: 50px auto;
                margin: 0 auto;
                margin-bottom: 50px;
                display: block;
            }
            .loginForm{
                input{
                    min-height: 72px;
                    padding-left: 70px;
                    font-size: 16px;
                    border-color: #999999; 
                    border-radius: 10px;
                }
                img{
                    position: absolute;
                    z-index: 9;
                    margin: 0;
                    left: 22px;
                    top: 18px;
                }
                // .ivu-input:focus{
                //     box-shadow:none
                // }
                .forgetPassword{
                    position: absolute;
                    right: 6px;
                    top: -30px;
                    z-index: 99;
                    color: #d12937;
                    font-size: 16px;
                }
                .remember{
                    display: inline-block;
                    width: 18px;
                    height: 18px;
                    border: 1px solid #a7a7a7;
                    border-radius: 5px;
                    vertical-align: middle;
                    margin-right: 8px;
                    margin-left: 5px;
                    cursor: pointer;
                    
                }
                .rememberTxt{
                    line-height: 34px;
                    color: #a7a7a7;
                    vertical-align: middle;
                    font-size: 16px;
                }
                .rememberCheck{
                    background: url('../assets/image/checked.png') center center no-repeat ;
                }
                .loginBtn{
                    border-radius: 25px;
                    line-height: 50px;
                    height: 50px;
                    background:#d60433;
                    color: #ffffff;
                    min-width: 200px;
                    font-size: 20px;
                    outline: none;
                    box-shadow:  0 0 25px rgba(0,0,0,.3)
                }
                .regBtn{
                    border-radius: 25px;
                    line-height: 50px;
                    height: 50px;
                    background:#ffffff;
                    color: #d12937;
                    min-width: 200px;
                    font-size: 20px;
                    outline: none;
                    border-color: #d02836;
                    box-shadow:  0 0 25px rgba(0,0,0,0.25);
                    min-width: 370px;
                    
                }
                
            }
            .firstFormItem{
                margin-bottom: 60px;
            }
        }
        .login-txt{
            width: 80%;
            // position: absolute;
            // bottom: 40px;
            left: 0;
            right: 0;
            margin: auto;
            margin-bottom: 40px;
            .footer_title{
                font-size: 16px;
                color: #8b8b8c;
                font-weight: 600;
                margin-bottom: 10px;
            }
            .footer_content{
                font-size: 14px;
                color: #8b8b8c;
                font-weight: 400;
                margin-bottom: 10px;
                span{
                    font-weight: 600;
                }
            }
        }
    }
</style>